import { render, staticRenderFns } from "./RetrievalQueries.vue?vue&type=template&id=2e97f2db&"
import script from "./RetrievalQueries.vue?vue&type=script&lang=ts&"
export * from "./RetrievalQueries.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports